import { t } from "@lingui/core/macro";
import { SubscriptionFreezeReason } from "@/server-types";

type SubscriptionFreezeOption = {
  value: SubscriptionFreezeReason;
  label: string;
};

export function getSubscriptionFreezeReasonOptions(): SubscriptionFreezeOption[] {
  return [
    {
      value: "Sickness",
      label: t`Bolezen`,
    },
    {
      value: "Vacation",
      label: t`Dopust`,
    },
    {
      value: "Other",
      label: t`Drugo`,
    },
  ];
}
